
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // Initialisiert i18next
import { persistencePromise } from './services/firebaseService';
import { ErrorBoundary } from './components/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';

import { LiveAnnouncerProvider } from './contexts/LiveAnnouncerContext';
import { reloadForNewVersion } from './utils/chunkReload';

// Vite meldet fehlgeschlagene dynamische Imports (z.B. veraltete Chunks nach einem Deploy)
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForNewVersion()) event.preventDefault();
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// VERIFICATION: Log the running React version to confirm security patch
console.log('%c CAF Suite Security Check ', 'background: #222; color: #bada55', `Running React Version: ${React.version}`);

const root = ReactDOM.createRoot(rootElement);

// Wait for persistence to be enabled before rendering the app.
persistencePromise.finally(() => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <LiveAnnouncerProvider>
            <React.Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-gray-50"><div className="animate-spin h-8 w-8 border-4 border-gray-200 border-t-gray-400 rounded-full"></div></div>}>
              <App />
            </React.Suspense>
          </LiveAnnouncerProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
});
